export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const LOADED = "LOADED";
export const MOBILE_VIEW = "MOBILE_VIEW";
